module.exports = __webpack_public_path__ + "static/media/appliances1.09ee9a27.jpg";